import { Container, ContainerProps } from '@chakra-ui/react';

export type PageContainerProps = ContainerProps;

export function PageContainer(props: ContainerProps) {
   return (
      <Container flex="1" display="flex" flexDirection="column" maxW="container.lg" {...props}>
         {props.children}
      </Container>
   );
}
